import React, { Component } from 'react';
import SWatchAndEarnInfo from 'shared/screens/VideoAds/Info';
import TimeRemainingText from '../../components/TimeRemainingText';
import ImageBW from '../../components/ImageBoundsWrapper';
import './VideoAds.scss';
import Utils from 'shared/utils/index';
import theme from 'shared/assets/style/theme';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class WatchAndEarnInfo extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-watchAndEarn-info',
    };
  }

  componentDidMount() {
    window.history.replaceState('', '', window.location.origin);
  }

  render() {
    return (
      <SWatchAndEarnInfo
        navigation={this.props.navigation}
        render={args => {
          return (
            <div className={'watchAndEarnInfoContainer' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
              <span
                style={{
                  textAlign: 'center',
                  fontSize: 'calc(18px + (30 - 18) * ((100vw - 800px) / (1600 - 800)))',
                  display: 'flex',
                  marginTop: Utils.ieVersion() !== 0 ? '1vmin' : '3.5vmin',
                  height: '6vmin',
                  fontWeight: 600,
                  textShadow: `2px 2px 4px ${theme.palette.common[0]}`,
                }}
                className={`watchAndEarnGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                data-label={'come back later'}
              >
                {getText(TEXT_KEY.COME_BACK_LATER)}
              </span>
              <ImageBW
                source={require(asset`Shop_VIP_Divider_Glows@3x.png`)}
                ibw={require(asset`Shop_VIP_Divider_Glows.ibw`)}
                manualAssetScale={3}
                style={{ height: '7vmin', width: '100%', marginTop: '1vmin' }}
                innerStyle={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                  paddingLeft: '1vmin',
                  paddingRight: '1vmin',
                }}
              ></ImageBW>
              <span className="watchAndEarnPopupIcon">
                <img
                  alt=""
                  src={require(asset`images/Watch_and_Earn_Assets/Watch&Earn_PopupIcon@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </span>
              <span
                style={{
                  fontSize: '1em',
                  marginTop: '-2.5em',
                  width: '90%',
                  textAlign: 'center',
                  textShadow: `${theme.palette.primary[16]} 1px 1px 4px`,
                }}
              >
                {getText(TEXT_KEY.ALREADY_WATCHED_ALL)}
              </span>
              <img
                alt=""
                src={require(asset`Shop_VIP_Divider@3x.png`)}
                style={{ width: '50%', height: '0.5vmin', marginTop: '1vmin', marginBottom: '0.8vmin' }}
              />
              <span style={{ fontSize: '1.1em', textShadow: `${theme.palette.primary[16]} 1px 1px 4px` }}>
                {getText(TEXT_KEY.COME_BACK_IN)}
              </span>
              <span className="timerContainer">
                <img
                  alt=""
                  src={require(asset`images/Watch_and_Earn_Assets/Timer_Backing@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
                <TimeRemainingText className="timeRemaining" until={args.videoAds.refreshDate} />
              </span>
            </div>
          );
        }}
      />
    );
  }
}

WatchAndEarnInfo.hideOverlay = true;

